import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { Ferias } from "../../models/ferias";
import { IGetFeriasUseCase } from "../../../presentation/useCases/read/get_ferias_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFeriasUseCase
 */

export class GetFeriasUseCase extends BasePaginatedUseCase<Ferias> implements IGetFeriasUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getFerias(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getFerias(idFuncionario, page, pageSize);

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}